import React from 'react';
import { Form, Skeleton } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faEnvelope, faPhone, faPen } from '@fortawesome/free-solid-svg-icons';
import {
  SettingsCard,
  CardHeader,
  CardTitle,
  CardTitleText,
  InfoRow,
  InfoLabel,
  InfoValue,
  FormSection,
  StyledInput,
  SaveChangesButton,
  CancelButton,
  ActionButtons,
  ActionIconButton,
} from './Styles';
import { useTheme } from '../../context/ThemeContext';
import type { PersonalInformationSectionProps } from './types';

const PersonalInformationSection: React.FC<PersonalInformationSectionProps> = ({
  user,
  editingSection,
  formData,
  loading,
  profileLoading,
  onEdit,
  onInputChange,
  onSave,
  onCancel,
}) => {
  const { isDarkMode } = useTheme();
  
  return (
    <SettingsCard>
      <CardHeader>
        <CardTitle>
          <FontAwesomeIcon icon={faUser} style={{ fontSize: 20, color: '#1890ff' }} />
          <CardTitleText level={4}>Personal Information</CardTitleText>
        </CardTitle>
        <ActionIconButton
          onClick={profileLoading ? undefined : onEdit}
          iconColor="#2D6CCA"
          style={{ opacity: profileLoading ? 0.5 : 1, cursor: profileLoading ? 'not-allowed' : 'pointer' }}
        >
          <FontAwesomeIcon icon={faPen} fontSize={14} color={isDarkMode ? '#fff' : '#222222'} />
        </ActionIconButton>
      </CardHeader>
      {editingSection !== 'personal' ? (
        <div>
          <InfoRow>
            <FontAwesomeIcon icon={faUser} style={{ fontSize: 16, color: '#1890ff' }} />
            <InfoLabel>Full Name:</InfoLabel>
            <InfoValue>
              {profileLoading ? (
                <Skeleton.Input active size="small" style={{ width: 150, height: 20 }} />
              ) : (
                user?.name || 'Not provided'
              )}
            </InfoValue>
          </InfoRow>
          <InfoRow>
            <FontAwesomeIcon icon={faEnvelope} style={{ fontSize: 16, color: '#1890ff' }} />
            <InfoLabel>Email Address:</InfoLabel>
            <InfoValue>
              {profileLoading ? (
                <Skeleton.Input active size="small" style={{ width: 150, height: 20 }} />
              ) : (
                user?.email || 'Not provided'
              )}
            </InfoValue>
          </InfoRow>
          <InfoRow>
            <FontAwesomeIcon icon={faPhone} style={{ fontSize: 16, color: '#1890ff' }} />
            <InfoLabel>Personal Phone Number:</InfoLabel>
            <InfoValue>
              {profileLoading ? (
                <Skeleton.Input active size="small" style={{ width: 150, height: 20 }} />
              ) : (
                user?.phone || 'Not provided'
              )}
            </InfoValue>
          </InfoRow>
        </div>
      ) : (
        <FormSection>
          <Form.Item label="Full Name">
            <StyledInput
              name="name"
              value={formData.name}
              onChange={onInputChange}
              placeholder="Enter your full name"
            />
          </Form.Item>
          <Form.Item label="Email Address">
            <StyledInput
              name="email"
              type="email"
              value={formData.email}
              onChange={onInputChange}
              placeholder="Enter your email"
            />
          </Form.Item>
          <Form.Item label="Personal Phone Number">
            <StyledInput
              name="phone"
              value={formData.phone}
              onChange={onInputChange}
              placeholder="Enter your personal phone number"
            />
          </Form.Item>
          <ActionButtons>
            <SaveChangesButton icon={<CheckOutlined />} onClick={onSave} loading={loading}>
              Save Changes
            </SaveChangesButton>
            <CancelButton onClick={onCancel}>
              Cancel
            </CancelButton>
          </ActionButtons>
        </FormSection>
      )}
    </SettingsCard>
  );
};

export default React.memo(PersonalInformationSection);

